var mapCallbackStatus = {}
var mapLibraryStatus = {}
function mapLibraryIsLoaded() {
  return Boolean(window['google']?.maps?.Map && mapCallbackStatus['google'])
}
export const loadMapsLibrary = async (mapType, apiKey) => {
  if (window.loadMapsLibrary) {
    return window.loadMapsLibrary(mapType, apiKey)
  } else {
    //TODO: remove this once studio code can be directly imported
    // this is a slimmed down version of the loadMapsLibrary function in MapHelper

    window['setMapsLibraryReadyGoogle'] = function () {
      mapCallbackStatus['google'] = true
    }

    return new Promise<void>((resolve, reject) => {
      var mapLibrary = 'google'

      if (!mapLibraryStatus[mapLibrary]) {
        mapLibraryStatus[mapLibrary] = 'loading'
        loadScript(
          [
            'https://maps.googleapis.com/maps/api/js?key=' +
              apiKey +
              '&v=3.61&libraries=places&callback=setMapsLibraryReadyGoogle',
          ],
          { async: '', defer: '' }
        )
      }

      var checkMapLoadedIntervalId = setInterval(function () {
        if (mapLibraryIsLoaded()) {
          mapLibraryStatus[mapLibrary] = 'ready'
          window.studioDebug && console.log('Maps library ready: ' + mapLibrary)
          clearInterval(checkMapLoadedIntervalId)
          resolve()
        } else if (mapLibraryStatus[mapLibrary] === 'error') {
          clearInterval(checkMapLoadedIntervalId)
          delete mapLibraryStatus[mapLibrary]
          reject('error')
        } else {
          window.studioDebug && console.log('Maps library not loaded: ' + mapLibrary)
        }
      }, 100)
    })
  }
}

function loadScript(scriptUrl, extraAttributes) {
  // Not working because these need to be loaded BEFORE react is initialized...
  var tag = document.createElement('script')
  tag.setAttribute('type', 'text/javascript')
  tag.setAttribute('src', scriptUrl)

  //e.g. async, defer
  if (extraAttributes) {
    for (var key in extraAttributes) {
      tag.setAttribute(key, extraAttributes[key])
    }
  }

  document.body.appendChild(tag)
}
